// スピナーを表示
export function spinnerShow () {
  let spinner = document.getElementById('spinners');
  if (!spinner) {
    let span = document.createElement('span');
    span.classList.add('sr-only')

    let inner = document.createElement('div');
    inner.classList.add('spinner-border');

    let spinner = document.createElement('div');
    spinner.classList.add('d-flex', 'justify-content-center', 'text-success');
    spinner.id = 'spinners';

    inner.appendChild(span);
    spinner.appendChild(inner);
    document.body.append(spinner);
  }
}

// スピナーを削除
export function spinnerHide () {
  let spinner = document.getElementById('spinners');
  if (!!spinner) {
    spinner.remove();
  }
}
